import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Permissions, NotaryTag } from '@autofact-lib/operation-lib-model-notary-platform';
import moment from 'moment';

import BackendApiService from '../../services/BackendApiService';
import TransferenceList from '../transference-list/TransferenceList';
import TransferenceHistoryList from '../transference-history-list/TransferenceHistoryList';
import ModalMessage from '../modal-message/ModalMessage';
import excelIcon from '../../theme/assets/ico-excel.png';
import AuthService from '../../services/AuthService';
import logCaughtException from '../../helpers/logCaughtException';
import { buildDefaultDateRange } from '../../helpers/transferenceListDateWindow';

class TransferenceListContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      transferenceList: [],
      params: this.props.filters || {},
      fetchParams: ['where', 'per_page', 'page', 'sorted'],
      exporting: false,
      exportingExcel: false,
      showMessage: false,
      exportResult: '',
      emp_mail: '',
      transferenceByTagSelected: {},
      selectedAll: false,
      tagValue: '',
      appliedWindow: null,
    };
    this.fetchData = this.fetchData.bind(this);
    this.download = this.download.bind(this);
    this.selectTransference = this.selectTransference.bind(this);
    this.transferenceListComponentRef = React.createRef();
  }

  async fetchData(params) {
    if (this.state.params.sorted
                && Object.keys(this.state.params.sorted).length
                && !Object.keys(JSON.parse(params.sorted)).length) {
      params.sorted = this.state.params.sorted;
    }

    params = Object.assign(this.state.params, params);
    params = this.filterParams(params);

    const transferenceList = this.props.tab === 'history' ? await BackendApiService.getTransferenceHistoryList(params) : await BackendApiService.getTransferenceList(params);
    const appliedWindow = transferenceList?.extra?.appliedWindow || null;
    this.setState({ params, transferenceList, appliedWindow });
    this.props.updateCount(transferenceList.extra.recordsTotal);
    if (typeof this.props.onAppliedWindowChange === 'function') {
      this.props.onAppliedWindowChange(appliedWindow);
    }
    return transferenceList;
  }

  filterParams(params) {
    const filtered = Object.keys(params)
      .filter((key) => this.state.fetchParams.includes(key))
      .reduce((obj, key) => {
        obj[key] = params[key];
        return obj;
      }, {});
    return filtered;
  }

  async exportData(format, from) {
    const { params } = this.state;
    params.format = format;
    params.from = from;
    let where = {};
    if (params.where) {
      where = typeof params.where === 'string' ? JSON.parse(params.where) : { ...params.where };
    }
    if (!where.DATE_FROM || !where.DATE_TO || !where.DATE_FIELD) {
      const fieldByTab = {
        forSign: 'numero_repertorio_timestamp',
        signed: 'numero_repertorio_timestamp',
        full: 'last_transition_timestamp',
        history: 'numero_repertorio_timestamp',
      };
      const field = where.DATE_FIELD
        || (this.props.dateFilter && this.props.dateFilter.field)
        || fieldByTab[this.props.tab]
        || 'firma_notario';
      const defaultRange = buildDefaultDateRange(field);
      where = {
        ...where,
        DATE_FROM: where.DATE_FROM || defaultRange.DATE_FROM,
        DATE_TO: where.DATE_TO || defaultRange.DATE_TO,
        DATE_FIELD: where.DATE_FIELD || defaultRange.DATE_FIELD,
      };
    }
    params.where = typeof this.state.params.where === 'string' ? JSON.stringify(where) : where;
    const exportResult = this.props.tab === 'history' ? await BackendApiService.getTransferenceHistoryList(params) : await BackendApiService.getTransferenceList(params);
    return exportResult.data;
  }

  download(format, from) {
    const link = document.createElement('a');
    link.target = '_blank';
    this.setState({ exporting: true, exportingExcel: true });
    this.exportData(format, from)
      .then((response) => {
        if (!response) {
          alert('Error exportando datos');
          this.setState({ exporting: false, exportingExcel: false });
          return;
        }

        if (format === 'pdf-package') {
          this.setState({ showMessage: true });
        }
        if (response?.url) {
          link.href = response.url;
          link.click();
          this.setState({ exporting: false, exportingExcel: false });
        } else {
          this.setState({ exporting: false, exportingExcel: false });
        }
      })
      .catch(() => {
        alert('Error exportando datos');
        this.setState({ exporting: false, exportingExcel: false });
      });
  }

  refreshFilters(filters) {
    this.setState({ params: filters });
    setTimeout(() => {
      this.transferenceListComponentRef.current.reloadData();
    }, 100);
  }

  componentDidMount() {
    // React ignores whatever componentDidMount returns, so the promise has to
    // be terminated here or a rejected session load becomes an unhandled one.
    this.loadSessionData().catch(logCaughtException);
  }

  async loadSessionData() {
    const session = await AuthService.getAuthData();
    if (session && session.usuario) {
      this.setState({
        emp_mail: session.usuario.mail || '',
      });
    }
  }

  async selectTransference(id, item, selected) {
    this.setState((prevState) => {
      let transferenceByTagSelected = { ...prevState.transferenceByTagSelected };
      let selectedAll = false;

      if (selected && (item === 'all' || !item.valorEtiqueta)) {
        if (item === 'all') {
          transferenceByTagSelected = {};
          for (let i = 0; i < prevState.transferenceList.data.length; i += 1) {
            transferenceByTagSelected[prevState.transferenceList.data[i].idtransferencia] = prevState.transferenceList.data[i];
          }
          selectedAll = selected;
        } else {
          transferenceByTagSelected[id] = item;
        }
      } else {
        if (item === 'all') {
          transferenceByTagSelected = {};
        }
        delete transferenceByTagSelected[id];
      }

      return {
        transferenceByTagSelected,
        selectedAll,
      };
    });
  }

  handleChangeTag = async (selectedTagOption) => {
    const transferenceListLocal = this.state.transferenceByTagSelected;
    await this.setStateAsync({ tagValue: selectedTagOption });

    const params = {
      transferences: [],
    };

    const keys = Object.keys(transferenceListLocal);
    const transferenceList = await Promise.all(keys.map((key) => new Promise((resolve) => {
      params.transferences.push({
        code: transferenceListLocal[key].codigo,
      });

      let transferenceList = null;
      for (let i = 0; i < this.state.transferenceList.data.length; i += 1) {
        if (transferenceListLocal[key].idtransferencia
                        === this.state.transferenceList.data[i].idtransferencia
        ) this.state.transferenceList.data.splice(i, 1);
        transferenceList = this.state.transferenceList;
      }
      resolve(transferenceList);
    })));

    const response = await BackendApiService.setTagEnteredToCivilregister(params);
    if (Object.prototype.hasOwnProperty.call(response, 'affectedRows')
            && response.affectedRows
            === Object.keys(
              this.state.transferenceByTagSelected,
            ).length
    ) {
      await this.setStateAsync({
        selectedAll: false,
        transferenceList,
        transferenceByTagSelected: {},
        tagValue: '',
      });
    }

    return response.affectedRows;
  };

  setStateAsync(state) {
    return new Promise((resolve) => {
      this.setState(state, resolve);
    });
  }

  render() {
    const listActions = [];
    switch (this.props.tab) {
      case 'repertory': {
        if (AuthService.canDo(Permissions.TRANSFERENCE_REPERTORY_EDIT)) {
          listActions.push(
            <div key="repertory-view">
              <Link key="massive-repertory" className="btn btn-primary-darker btn-sm mr-2" to="transferencias/asignar-repertorio-masivo">
                Repertorios rápidos
              </Link>
            </div>,
          );
        }
        break;
      }
      case 'signed': {
        listActions.push(
          <div key="signed-view">
            <button
              type="button"
              key="export-pdf-package"
              className="btn btn-gray btn-sm actions"
              onClick={() => this.download('pdf-package', null)}
              disabled={this.state.exporting}
            >
              <FontAwesomeIcon icon="file-pdf" />
              {this.state.exporting ? 'Exportando...' : 'Exportar PDF Paquete'}
            </button>
            {this.state.exportResult
              ? (
                <a
                  key="export-xls-download"
                  href={this.state.exportResult}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => this.setState({ exportResult: '' })}
                  className="btn donwload-button btn-sm actions"
                  disabled={this.state.exporting}
                >
                  <FontAwesomeIcon icon="file-download" />
                  Descargar Excel
                </a>
              )
              : (
                <button
                  type="button"
                  key="export-xls"
                  className="btn btn-gray btn-sm actions"
                  onClick={() => this.download('xlsx', 'signed')}
                  disabled={this.state.exporting}
                >
                  <img src={excelIcon} alt="Excel icon" />
                  {this.state.exportingExcel ? 'Exportando...' : 'Exportar a Excel'}
                </button>
              )}
          </div>,
        );
        break;
      }
      case 'forSign': {
        listActions.push(
          <div key="repertory-view">
            {this.state.exportResult
              ? (
                <a
                  key="export-xls-download"
                  href={this.state.exportResult}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => this.setState({ exportResult: '' })}
                  className="btn donwload-button btn-sm actions"
                  disabled={this.state.exporting}
                >
                  <FontAwesomeIcon icon="file-download" />
                  Descargar Excel
                </a>
              )
              : (
                <button
                  type="button"
                  key="export-xls"
                  className="btn btn-gray btn-sm actions"
                  onClick={() => this.download('xlsx', null)}
                  disabled={this.state.exportingAll}
                >
                  <img src={excelIcon} alt="Excel icon" />
                  {this.state.exportingAll ? 'Exportando...' : 'Exportar a Excel'}
                </button>
              )}
          </div>,
        );
        break;
      }
      case 'full': {
        listActions.push(
          <div key="repertory-view">
            {this.state.exportResult
              ? (
                <a
                  key="export-xls-download"
                  href={this.state.exportResult}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => this.setState({ exportResult: '' })}
                  className="btn donwload-button btn-sm actions"
                  disabled={this.state.exporting}
                >
                  <FontAwesomeIcon icon="file-download" />
                  Descargar Excel
                </a>
              )
              : (
                <button
                  type="button"
                  key="export-xls"
                  className="btn btn-gray btn-sm actions"
                  onClick={() => this.download('xlsx', 'full')}
                  disabled={this.state.exporting}
                >
                  <img src={excelIcon} alt="Excel icon" />
                  {this.state.exportingExcel ? 'Exportando...' : 'Exportar a Excel'}
                </button>
              )}
          </div>,
        );
        break;
      }
      default: {
        break;
      }
    }

    return (
      <div>
        {this.state.appliedWindow && this.state.appliedWindow.applied && this.state.appliedWindow.from
          ? (
            <div className="alert alert-info py-2 px-3 mb-2" role="status">
              Mostrando por
              {' '}
              {(this.state.appliedWindow.label || 'fecha').toLowerCase()}
              {' '}
              desde el
              {' '}
              {moment(this.state.appliedWindow.from).format('DD-MM-YYYY')}
              {' '}
              hasta el
              {' '}
              {moment(this.state.appliedWindow.to).format('DD-MM-YYYY')}
              {' '}
              (máx.
              {' '}
              {this.state.appliedWindow.days || 365}
              {' '}
              días)
              {this.state.appliedWindow.clamped ? '. El rango se ajustó al tope configurado.' : '.'}
            </div>
          )
          : null}
        <div className={`mark-as-entered ${this.props.tab === 'full' ? '' : 'not-show'}`}>
          <Select
            value={this.state.tagValue}
            onChange={this.handleChangeTag}
            options={
                            Object.keys(NotaryTag).map((typeId) => {
                              const type = NotaryTag[typeId];
                              if (type && type.id === 0) {
                                return {
                                  value: type.id,
                                  label: type.label,
                                };
                              }
                              return {};
                            })
                        }
            name="tag"
            id="tag"
            className={`form-control-sm ${Object.keys(this.state.transferenceByTagSelected).length ? '' : 'not-show'}`}
          />
        </div>
        {this.props.tab !== 'history' && (
        <TransferenceList
          ref={this.transferenceListComponentRef}
          id={this.props.id}
          selected={this.state.transferenceByTagSelected}
          selectRowByTag={this.selectTransference}
          fetchDataCallback={this.fetchData}
          selectedAll={this.state.selectedAll}
        />
        )}

        {this.props.tab === 'history' && (
        <TransferenceHistoryList
          ref={this.transferenceListComponentRef}
          id={this.props.id}
          fetchDataCallback={this.fetchData}
        />
        )}
        {this.state.showMessage
          ? <ModalMessage message={`Se esta generando el paquete que se enviará al correo: ${this.state.emp_mail}`} messageType="success" />
          : ''}
        <div className="action-buttons">
          {listActions}
        </div>
      </div>
    );
  }
}

TransferenceListContainer.propTypes = {
  id: PropTypes.string,
  tab: PropTypes.string,
  dateFilter: PropTypes.shape({
    field: PropTypes.string,
    label: PropTypes.string,
  }),
  filters: PropTypes.object,
  updateCount: PropTypes.func,
  onAppliedWindowChange: PropTypes.func,
};

export default TransferenceListContainer;
